module.exports = __webpack_public_path__ + "img/Susan.2d32066.png";